module.exports = __webpack_public_path__ + "static/media/nextButton.709d2feb.svg";